import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { AuthGuardAdmin } from 'src/auth/guard/auth-guard';
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/main-dashboard/app'));
const FAQs = lazy(() => import('src/pages/dashboard/main-dashboard/faqs'));
const Terms = lazy(() => import('src/pages/dashboard/main-dashboard/terms'));
const Privacy = lazy(() => import('src/pages/dashboard/main-dashboard/policy'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/main-dashboard/user/account'));
const File = lazy(() => import('src/pages/dashboard/main-dashboard/file/file'));
const FileDetailPage = lazy(() => import('src/pages/dashboard/main-dashboard/file/file-detail-page'));
const FileManager = lazy(() => import('src/pages/dashboard/file-manager'));
const ProjectManager = lazy(() => import('src/pages/dashboard/project-manager'));
const AboutUs = lazy(() => import('src/pages/dashboard/main-dashboard/about-us'));
const UserList = lazy(() => import('src/pages/dashboard/main-dashboard/user/list'));
const CategoryPage = lazy(() => import('src/pages/dashboard/main-dashboard/category/category-page'));
const SupportPage = lazy(() => import('src/pages/dashboard/main-dashboard/support'));
const ContactUs = lazy(() => import('src/pages/dashboard/main-dashboard/contact-us'));
const BannerPage = lazy(() => import('src/pages/dashboard/main-dashboard/banner/banner-page'));
const UploadPage = lazy(() => import('src/pages/dashboard/upload-manager'));
// ----------------------------------------------------------------------

export const admindashboardRoutes = [
  {
    path: 'admin-dashboard',
    element: (
      <AuthGuardAdmin>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuardAdmin>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: "file", element: <File /> },
      { path: "category-manager", element: <FileManager /> },
      { path: "project-manager", element: <ProjectManager /> },
      { path: "uploads", element: <UploadPage /> },
      { path: "faqs", element: <FAQs /> },
      { path: 'file/:id', element: <FileDetailPage /> },
      { path: "terms", element: <Terms /> },
      { path: "privacy", element: <Privacy /> },
      { path: 'profile', element: <UserAccountPage /> },
      { path: 'about-us', element: <AboutUs /> },
      { path: 'users', element: <UserList /> },
      { path: 'category', element: <CategoryPage /> },
      { path: 'banner', element: <BannerPage /> },
      { path: 'contact-support', element: <SupportPage /> },
      { path: 'contact-us', element: <ContactUs /> },
    ],
  },
];
